import React, { Component } from 'react';
import PropTypes from "prop-types";
import ImageCarouselView from "./ImageCarouselView";
import PrivateSpaceCardDetailsGoogleMapView from "./PrivateSpaceCardDetailsGoogleMapView";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import EventPublisher from "../../utils/EventPublisher";
import Calendar from 'react-calendar'

import Time from "../../utils/Time";
import 'react-calendar/dist/Calendar.css';
import {DISABLED_FROM_TODAY_DURATION, START_OF_TIME} from "../../constants/GeneralConstants"
import Money from "../../utils/Money";

const TODAY = new Date();
const DISABLED_UNTIL = Time.addTimeToDuration(TODAY, DISABLED_FROM_TODAY_DURATION)
const DISABLED_RANGES = [
    [START_OF_TIME, DISABLED_UNTIL],
];


export default class SpaceDetailsView extends Component {

    static propTypes = {
        isSaving: PropTypes.bool.isRequired,
        spaceId: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        pricePerDay: PropTypes.number.isRequired,
        minimumDays: PropTypes.number.isRequired,
        distance: PropTypes.number.isRequired,
        created: PropTypes.number.isRequired,
        longitude: PropTypes.number.isRequired,
        latitude: PropTypes.number.isRequired,
        imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
        status: PropTypes.string.isRequired,
        unavailableDates: PropTypes.array.isRequired,
        myOpenAdvertisements: PropTypes.array.isRequired,
        currentSelectedAdvertisement: PropTypes.object.isRequired,
        currentSelectedReservationRange: PropTypes.array.isRequired,
        showSelectedRangeIsTooShortAlert: PropTypes.bool.isRequired,
        showSelectedRangeOverlapsUnavailableRangeAlert: PropTypes.bool.isRequired,
    };

    render() {
        return (
            <div className="card mb-2">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-10 col-sm-6 col-12">
                            <h2 className="card-title">{this.props.title}</h2>
                        </div>
                        <div className="col-md-2 col-sm-6 col-12 text-right">
                            <div>
                                <h4>
                                    {Money.formatMoney(this.props.pricePerDay)} per day
                                </h4>
                            </div>
                            <div>
                                <h5>
                                    minimum {this.props.minimumDays} days
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <ImageCarouselView id={this.props.spaceId} imageNames={this.props.imageNames} imageClassName="card-img-view-space"/>
                        </div>
                        {this._renderReserveSpace()}
                    </div>
                    <div className="card-body" id={this.props.spaceId}>
                        <h4>Description</h4>
                        {this.renderDescription()}
                        <h4>Location</h4>
                        <PrivateSpaceCardDetailsGoogleMapView
                            latitude={this.props.latitude}
                            longitude={this.props.longitude}/>
                    </div>
                </div>
            </div>
        );
    }

    renderDescription() {
        const descriptionParagraphs =
            this.props.description.split(/\r?\n/)
                .map(this.convertSpacesToBlankLine)
                .filter(this.isFirstOrNotSuccessiveEmptyParagraph)
                .reduce(this.mergeBrSeparated, [])
                .map(this.convertToHTML);
        return (
            <div className="card-text p-3 bg-white rounded mb-2">
                {descriptionParagraphs}
            </div>
        );
    }

    mergeBrSeparated(accumulator, currentValue, currentIndex, all) {
        if (currentIndex !== 0 && all[currentIndex-1] !== "") {
            const previousValue = accumulator.pop();
            accumulator.push(
                <React.Fragment key={"fl-"+currentIndex}>
                    {previousValue}
                    <br/>
                    {currentValue}
                </React.Fragment>
            );
            return accumulator;
        }
        accumulator.push(currentValue);
        return accumulator;
    }

    convertToHTML(line, currentIndex, all) {
        if (line === "") {
            return null;
        }
        return (<p key={"pl-"+currentIndex}>{line}</p>);
    }

    convertSpacesToBlankLine(line) {
        if (line.match(/^[\s]*$/g)) {
            return "";
        }
        return line;
    }

    isFirstOrNotSuccessiveEmptyParagraph(line, index, all) {
        if (index === 0) {
            return true;
        }
        return !(line === "" && all[index - 1] === "");
    }

    _renderReserveSpace() {
        if (this.props.status === "UNLISTED") {
            return (
                <div className="col-md-4 text-center align-self-center mt-sm-3">
                    <div className="alert alert-danger" role="alert">
                        Space Is currently unavailable
                    </div>
                </div>);
        }

        let reservationSelectionTooShortAlert = null;
        if (this.props.showSelectedRangeIsTooShortAlert) {
            reservationSelectionTooShortAlert = (
                <div className="alert alert-danger fade show" role="alert">
                    Reservations must be at least {this.props.minimumDays} days in length for this space.
                    <button type="button" className="close" onClick={this.handleTooShortErrorAlertClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            );
        }


        let reservationSelectionOverlapsUnavailableDatesAlert = null;
        if (this.props.showSelectedRangeOverlapsUnavailableRangeAlert) {
            reservationSelectionOverlapsUnavailableDatesAlert = (
                <div className="alert alert-danger fade show" role="alert">
                    Reservations cannot overlap with unavailable time ranges.
                    <button type="button" className="close" onClick={this.handleRangeOverlapErrorAlertClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            );
        }

        const unavailableRanges = [];
        for (const unavailableRange of this.props.unavailableDates) {
            unavailableRanges.push(
                [
                    Time.parseDate(unavailableRange.startDate),
                    Time.parseDate(unavailableRange.endDate)
                ]
            );
        }

        const openAdvertisementsOptions = [];
        for (const openAdvertisement of this.props.myOpenAdvertisements) {
            openAdvertisementsOptions.push(
                <option value={openAdvertisement.advertisementId} key={"OpenAd-"+openAdvertisement.advertisementId}>
                    {openAdvertisement.title}
                </option>
            );
        }

        let buttonIcon = (<i className="fas fa-envelope-open-text mr-1"/>);
        if (this.props.isSaving) {
            buttonIcon = (<span className="spinner-border spinner-border mr-1"/>);
        }

        return (
            <div className="col-md-4">
                <div className="row">
                    <div className="input-group">
                        <select
                                className="custom-select"
                                id="myOpenAdvertisementsSelect"
                                defaultValue={-1}
                                onChange={this.handleAdvertisementSelectChanged}
                        >
                            <option value={-1} key={"OpenAd--1"}>Choose Advertisement</option>
                            {openAdvertisementsOptions}
                        </select>
                        <div className="input-group-append">
                            <button
                                className="btn btn-outline-success"
                                type="button"
                                onClick={this.handleCreateNewAdvertisementClicked}
                            >
                                <i className="fas fa-plus mr-1" />
                                Create New
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <Calendar
                        calendarType="US"
                        view="month"
                        className="w-100"
                        selectRange={true}
                        value={this.isRangeSelected() ? this.props.currentSelectedReservationRange : null}
                        tileDisabled={
                            ({date, view}) => {
                                return Time.isWithinRanges(date, DISABLED_RANGES) ||
                                    Time.isWithinRanges(date, unavailableRanges);
                            }
                        }
                        onChange={
                            ([rangeStart, rangeEnd]) => {
                                EventPublisher.publish(
                                    UIInteractionEvents.PRIVATE_SPACE_DETAILS_CALENDAR_SELECT_RANGE_CHANGED,
                                    {
                                        currentSelectionStartDate: new Date(rangeStart.toLocaleDateString()),
                                        currentSelectionEndDate: new Date(rangeEnd.toLocaleDateString())
                                    });
                            }
                        }
                    />
                </div>
                <div className="row">
                    {reservationSelectionTooShortAlert}
                </div>
                <div className="row">
                    {reservationSelectionOverlapsUnavailableDatesAlert}
                </div>
                <div className="row justify-content-center">
                    <button
                        className="btn btn-lg btn-primary"
                        disabled={
                            !this.isRangeSelected() || this.props.currentSelectedAdvertisement.advertisementId === -1 || this.props.isSaving
                        }
                        data-toggle="modal"
                        data-target={"#reservation_confirmation_modal"}
                    >
                        {buttonIcon}
                        Request Reservation
                    </button>
                </div>
                {this._renderConfirmationModal()}
            </div>
        );
    }

    _renderConfirmationModal() {
        let timeSpan = 0;
        let formattedStart = "Never";
        let formattedEnd = "Ever";
        if (this.isRangeSelected()) {
            timeSpan =
                Time.calculateDifferenceInDaysBetweenInclusive(
                    this.props.currentSelectedReservationRange[0],
                    this.props.currentSelectedReservationRange[1]);
            formattedStart = this.props.currentSelectedReservationRange[0].toLocaleDateString();
            formattedEnd = this.props.currentSelectedReservationRange[1].toLocaleDateString();
        }

        let buttonIcon = (<i className="fas fa-paper-plane mr-1"/>);
        if (this.props.isSaving) {
            buttonIcon = (<span className="spinner-border spinner-border mr-1"/>);
        }

        return (
            <div
                className="modal fade"
                id="reservation_confirmation_modal"
                tabIndex="-1"
                data-backdrop="static"
                role="dialog"
                aria-labelledby={"reservation_confirmation_modal"}
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modal_confirmation_label" >Confirm Reservation Request</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            You are about to request a reservation to host your advertisement <strong>
                            {this.props.currentSelectedAdvertisement.title}</strong> at space <strong>
                            {this.props.title}</strong>.
                            <br/>
                            This would happen for a total of <strong>{timeSpan}</strong> days from {formattedStart}
                            until {formattedEnd}.
                            <br/>
                            The cost per day is {Money.formatMoney(this.props.pricePerDay)} which means, your
                            total cost would be <strong className="text-cuvered-light-blue">
                            {Money.formatMoney(this.props.pricePerDay * timeSpan)}
                            </strong> before taxes.
                            <br/>
                            Once you submit your request the Space Owner will have <strong>72</strong> hours to
                            accept or reject your reservation.  If they accept, you will have <strong>24 </strong>
                            hours to make the payment.
                            <br/>
                            <strong> Once payment has been made it is your responsibility as the advertiser to deliver
                            the advertising materials to the Space Owner on time, and as described in your
                            Advertisement. </strong>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button
                                type="button"
                                className="btn btn-success"
                                data-dismiss="modal"
                                onClick={this.handleRequestSpaceReservationClicked}
                                disabled={this.props.isSaving}
                            >
                                {buttonIcon}
                                Send Request
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    isRangeSelected() {
        return this.props.currentSelectedReservationRange.length !== 0;
    }

    handleRequestSpaceReservationClicked = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.PRIVATE_SPACE_DETAILS_RESERVATION_REQUEST_CLICKED,
            {
                spaceId: this.props.spaceId,
                advertisementId: this.props.currentSelectedAdvertisement.advertisementId,
                startDate: Time.stringifyDate(this.props.currentSelectedReservationRange[0]),
                endDate: Time.stringifyDate(this.props.currentSelectedReservationRange[1])
            });
    };

    handleCreateNewAdvertisementClicked = (event) => {
        EventPublisher.publish(UIInteractionEvents.PRIVATE_SPACE_DETAILS_CREATE_NEW_ADVERTISEMENT_CLICKED, {});
    };

    handleTooShortErrorAlertClose = (event) => {
        EventPublisher.publish(UIInteractionEvents.PRIVATE_SPACE_DETAILS_CLOSE_SELECTED_RANGE_TOO_SHORT_ALERT_CLICKED, {});
    };

    handleRangeOverlapErrorAlertClose = (event) => {
        EventPublisher.publish(UIInteractionEvents.PRIVATE_SPACE_DETAILS_CLOSE_RANGE_CROSSING_ALERT_CLICKED, {});
    };

    handleAdvertisementSelectChanged = (event) => {
        const advertisementId = parseInt(event.target.value, 10);
        if (advertisementId === -1) {
            return;
        }
        EventPublisher.publish(
            UIInteractionEvents.PRIVATE_SPACE_DETAILS_ADVERTISEMENT_SELECT_CHANGED,
            {
                selectedAdvertisement: this.getSelectedAdvertisement(advertisementId)
            });
    };

    getSelectedAdvertisement(advertisementId) {
        for(const advertisement of this.props.myOpenAdvertisements) {
            if (advertisement.advertisementId === advertisementId) {
                return advertisement;
            }
        }
        throw new Error("Selected Advertisement Does not exist: "+advertisementId);
    }

}

